<div class="exercise-gauge-bar">
    <div class="gauge-bg"></div>
    <div class="gauge-planned" [style.width.%]="plannedPercentage"></div>
    <div class="gauge-used" [style.width.%]="usedPercentage"></div>

    <div class="gauge-stats">
    <span class="gauge-done">{{ hoursDone | toHourMinute:true }}</span>
        <span class="gauge-total">/ {{ totalHours }}h</span>
    </div>
</div>